import type { ScaleBand } from 'd3-scale';
import { useTheme } from '@simplywallst/ui-core';
import { Postfix, Label } from './styled';

interface Props {
  yScale: ScaleBand<string>;
  series: string[];
  y: number;
  labelRender?: (
    series: string,
    label1Y: number,
    label2Y: number
  ) => React.ReactNode;
}

const YAxis = ({
  yScale,
  series,
  y,
  labelRender = (series, label1Y, label2Y) => (
    <>
      <Label y={label1Y} dominantBaseline="hanging" textAnchor="start">
        {series}
      </Label>
      <Postfix y={label2Y} dominantBaseline="hanging" textAnchor="start">
        months
      </Postfix>
    </>
  ),
}: Props) => {
  const theme = useTheme();
  return (
    <svg y={y} width="100%" height={yScale.range()[1]}>
      {series.map((n, i) => {
        return (
          <g key={`insider-trading-yaxis-${n}`}>
            {labelRender(
              n,
              i * yScale.bandwidth() + theme.x1spacePx,
              i * yScale.bandwidth() + theme.x4spacePx
            )}
            <rect
              x="0"
              y={i * yScale.bandwidth()}
              width="100%"
              height="1"
              fill={theme.color.white}
              fillOpacity={0.1}
            />
          </g>
        );
      })}
    </svg>
  );
};

export default YAxis;
